import semver from 'semver';

import { PLATFORMS } from 'app/utils/constants';
import { toParams } from 'app/utils/url';

const { APP_STORE_URL, APP_STORE_PROVIDER_TOKEN, PLAY_STORE_URL, DOMAIN } =
  process.env;

const checkUserAgent = (userAgent) => {
  if (!userAgent) {
    return null;
  }

  const lUserAgent = userAgent.toLowerCase();
  if (lUserAgent.includes('chatie-ios')) {
    return PLATFORMS.IOS;
  } else if (lUserAgent.includes('chatie-android')) {
    return PLATFORMS.ANDROID;
  }

  return null;
};

const isIos = (userAgent) => RegExp(/iP(hone|od|ad)/).test(userAgent);

const isAndroid = (userAgent) => RegExp(/Android/).test(userAgent);

const isMobile = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
};

const isMobileSafari = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return (
    RegExp(/iP(hone|od|ad)/).test(navigator.userAgent) &&
    RegExp(/AppleWebKit/).test(navigator.userAgent)
  );
};

const checkIosVersion = (userAgent) => {
  if (isIos(userAgent)) {
    const v = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return parseInt(v[1], 10);
  }

  return null;
};

const goToStore = (
  { source = 'chatie', campaign = 'chatie_share', medium, term, content },
  skipConfirm = false
) => {
  // TODO : 기기확인변경
  const { userAgent } = navigator;

  if (isIos(userAgent)) {
    if (
      skipConfirm ||
      window.confirm('앱에서만 이용가능합니다. 앱을 설치하시겠습니까?')
    ) {
      const params = toParams({
        pt: APP_STORE_PROVIDER_TOKEN,
        ct: `${source}+${campaign}+${medium}+${term}`,
      });

      window.location.href = `${APP_STORE_URL}&${params}`;
    }
  } else if (isAndroid(userAgent)) {
    if (
      skipConfirm ||
      window.confirm('앱에서만 이용가능합니다. 앱을 설치하시겠습니까?')
    ) {
      const params = toParams({
        utmSource: source ? source : 'undefined',
        utmCampaign: campaign,
        utmMedium: medium,
        utmTerm: term,
        utmContent: content,
      });
      const referrer = encodeURIComponent(params);

      const url = `${PLAY_STORE_URL}&referrer=${referrer}`;

      window.location.href = url;
    }
  } else {
    alert('안드로이드, IOS 앱에서만 이용가능합니다.');
  }
};

/**
 * @param {string} type
 * @param {string} version
 */
const getAppVersion = (type, version = null) => {
  let match = null;
  let versionString = version;
  if (version === null) {
    const { userAgent } = navigator;
    versionString = userAgent.toLowerCase();
  }

  if (type === PLATFORMS.IOS) {
    match = versionString.match(RegExp(/chatie-ios\/(\d+.\d+.\d+)/));
  } else if (type === PLATFORMS.ANDROID) {
    match = versionString.match(RegExp(/chatie-android\/(\d+.\d+.\d+)/));
  }

  return match ? match[1] : null;
};

const goToRecharge = (platform, version, inflow, cancel = null) => {
  const r = window.confirm('풍선이 부족합니다. 충전소로 이동하시겠습니까?');
  const inflowStr = inflow ? `?inflow=${inflow}` : '';
  if (r) {
    if (
      (platform === PLATFORMS.ANDROID && semver.gte(version, '2.13.1')) ||
      (platform === PLATFORMS.IOS && semver.gte(version, '2.10.1'))
    ) {
      window.location.href = `chatie-app://payment${inflowStr}`;
      return;
    }

    if (!platform) {
      return (window.location.href = `${DOMAIN}/payment`);
    }

    window.location.href = 'chatie-app://offerwall';
  } else {
    cancel && cancel();
  }
};

const isRequiredAppVersion = (platform, version, compare = {}) => {
  const { ios: iOSVersion, android: androidVersion } = compare;
  return (
    (platform === PLATFORMS.IOS && semver.gte(version, iOSVersion)) ||
    (platform === PLATFORMS.ANDROID && semver.gte(version, androidVersion))
  );
};

const isEqualAppVersion = (platform, version, compare = {}) => {
  const { ios: iOSVersion, android: androidVersion } = compare;
  return (
    (platform === PLATFORMS.IOS && version === iOSVersion) ||
    (platform === PLATFORMS.ANDROID && version === androidVersion)
  );
};

const goToSignin = (
  data = { history, replace: false, message: null, next: null }
) => {
  const { history: _history, replace, message, next } = data;
  let history = _history;

  if (data.location) {
    history = data;
  }

  if (message) {
    alert(message);
  }

  const encodedNext = history.location
    ? encodeURIComponent(
        `${history.location.pathname}${history.location.search}`
      )
    : '';
  if (replace) {
    return history.replace(`/signin?next=${encodedNext}`, { canGoBack: false });
  }
  return history.push(`/signin?next=${next || encodedNext}`, {
    canGoBack: next ? false : true,
  });
};

export default {
  isIos,
  isAndroid,
  isMobile,
  isMobileSafari,
  checkUserAgent,
  checkIosVersion,
  goToStore,
  getAppVersion,
  goToRecharge,
  isRequiredAppVersion,
  isEqualAppVersion,
  goToSignin,
};



// WEBPACK FOOTER //
// ./src/app/utils/device.js